import * as React from 'react';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface FinalCTAProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function FinalCTA({}: FinalCTAProps) {
  return (
    <section className="bp-final-cta">
      <style>{`
        .bp-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .bp-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .bp-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .bp-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .bp-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .bp-final-ctas a {
          min-width: 220px;
          justify-content: center;
        }
        @media (max-width: 640px) {
          .bp-final-cta {
            padding: 60px 24px;
          }
          .bp-final-cta h2 {
            font-size: 24px;
          }
          .bp-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .bp-final-ctas a {
            justify-content: center;
          }
        }
      `}</style>
      <div className="bp-final-inner">
        <h2>Dejá de resignarte a lo que hay en la góndola.</h2>
        <p>Probá la diferencia de comer frutas y verduras recién llegadas del mercado.</p>
        <div className="bp-final-ctas">
          <a href={route('products.index')} className="bp-btn-primary">
            <i className="fa fa-shopping-basket" /> Ver Productos
          </a>
          <a href={route('login')} className="bp-btn-secondary" onClick={() => trackSignupClicked('barrios-privados', 'footer')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
